import { render, staticRenderFns } from "./resetLoginDc.vue?vue&type=template&id=4d292618&scoped=true"
import script from "./resetLoginDc.vue?vue&type=script&lang=js"
export * from "./resetLoginDc.vue?vue&type=script&lang=js"
import style0 from "./resetLoginDc.vue?vue&type=style&index=0&id=4d292618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d292618",
  null
  
)

export default component.exports